/**
 * ImageScreenshot Class
 */
export class ImageScreenshot {

	/**
	 * Constructor
	 *
	 * @param {string} containerEl
	 * @return {void}
	 */
	constructor( containerEl ) {

		this.allBlocks = document.querySelectorAll( containerEl );
		if ( !this.allBlocks || this.allBlocks.length === 0 ) {

			return false;

		}

		this.init();

	}




	/**
	 * Move out Overlay from the default wrapper
	 * @param {node} modal
	 * @param {node} overlay
	 * @return {void}
	 */
	moveOutOverlay( modal, overlay ) {

		document.body.appendChild( overlay );
		document.body.appendChild( modal );

	}

	/**
	 * Move Overlay to the default wrapper
	 * @param {node} modal
	 * @param {node} overlay
	 * @param {node} block
	 * @return {void}
	 */
	moveOverlayToBegin(  modal, overlay, block ) {

		block.appendChild( overlay );
		block.appendChild( modal );

	}

	/**
	 * Init
	 *
	 * @return {void}
	 */
	init() {

		if ( this.allBlocks.length > 0 ) {

			this.allBlocks.forEach( ( block ) => {

				if ( block.classList.contains( "is-style-screenshot" ) ) {

					const screenshotTop = document.createElement( 'div' );
					screenshotTop.classList.add( 'screenshot-top' );

					const span = document.createElement( 'span' );
					screenshotTop.append( span );
					block.insertBefore( screenshotTop, block.firstChild );


				}

			} );

		}

	}

}
